import axios from "axios";

export const LeaderboardService = {
  getLeaderboard: () => axios.get(`/payroll/leaderboard`, { auth: true }),
};